import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Custom validator function
export function isEconetSubscriberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = String(control.value || '').trim();
        const isValidEconetNumber = /^07[789]\d{7}$/.test(value) && value.length === 10;
        return isValidEconetNumber ? null : { isEconetSubscriber: true };  // Return error if not valid
    };
}

export function validPhoneNumber(phone : any): boolean{
    const value = String(phone || '').trim();
    return /^07[789]\d{7}$/.test(value) && value.length === 10;
}
